<template>
  <div class="box">
    <div class="main-content">
      <!-- 习题类型部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题类型:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="questionType-box flex spaceBetween">
              <div @click="selectQuestionType(1)" :class="this.selectType == 'single' ? 'selectType' : 'unSelectType'">
                单选题</div>
              <div @click="selectQuestionType(2)" :class="this.selectType == 'multi' ? 'selectType' : 'unSelectType'">
                多选题</div>
              <div @click="selectQuestionType(3)"
                :class="this.selectType == 'truefalse' ? 'selectType' : 'unSelectType'">判断题</div>
              <div @click="selectQuestionType(4)" :class="this.selectType == 'answer' ? 'selectType' : 'unSelectType'">
                简答题</div>
              <div @click="selectQuestionType(5)" :class="this.selectType == 'blank' ? 'selectType' : 'unSelectType'">
                填空题</div>
            </div>
            <div v-show="!editableOrNot" class="questionType-box flex spaceBetween">
              <div :class="this.selectType == 'single' ? 'superSelectType' : 'superUnSelectType'">单选题</div>
              <div :class="this.selectType == 'multi' ? 'superSelectType' : 'superUnSelectType'">多选题</div>
              <div :class="this.selectType == 'truefalse' ? 'superSelectType' : 'superUnSelectType'">判断题</div>
              <div :class="this.selectType == 'answer' ? 'superSelectType' : 'superUnSelectType'">简答题</div>
              <div :class="this.selectType == 'blank' ? 'superSelectType' : 'superUnSelectType'">填空题</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 习题类型部分结束 -->
      <!-- 习题分值部分开始 -->
      <div v-if="this.selectType != 'blank'" class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题分值:</div>
          </div>
          <div class="flex main-content-right">
            <input v-show="editableOrNot" class="linkageNameScore-range" @input="exampleageNameScoreInput"
              :value="exampleageNameScore || 0" type="range" min="0" max="100" />
            <input v-show="!editableOrNot" disabled class="linkageNameScore-range" @input="exampleageNameScoreInput"
              :value="exampleageNameScore || 0" type="range" min="0" max="100" />
            <input v-show="editableOrNot" onBlur="if(value == '')value = 0" class="linkageNameScore-text"
              v-model="exampleageNameScore"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=0" />
            <input v-show="!editableOrNot" disabled class="linkageNameScore-text" v-model="exampleageNameScore" />
          </div>
        </div>
      </div>
      <!-- 习题分值部分结束 -->
      <!-- 习题分值部分开始 -->
      <div v-if="this.selectType == 'blank'" class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题分值:</div>
          </div>
          <div class="flex main-content-right">
            <input disabled class="linkageNameScore-range" @input="exampleageNameScoreInput"
              :value="exampleageNameScore || 0" type="range" min="0" max="100" />
            <input disabled class="linkageNameScore-text" v-model="exampleageNameScore" />
          </div>
        </div>
      </div>
      <!-- 习题分值部分结束 -->
      <!-- 所属课次部分开始 -->
      <div v-if="!this.$route.params.examId" class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in classList" :key="index"
                  v-model="checked">
                  <van-checkbox shape="square" @click="changeCheckbox(item.name, item.id)" :name="item.name">课次 {{ index
              + 1 }} {{ item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div v-show="editableOrNot" @click="showPopover = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput1" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopover = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
                <div v-show="!editableOrNot" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput1" type="text" placeholder="请选择所属课次" />
                  <img style="margin-right: 17px" src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
      </div>
      <!-- 所属课次部分结束 -->
      <!-- 习题用途部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题用途:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="examplePurpose-box flex spaceBetween">
              <div @click="examplePurpose = 'front'" class="flex align pointer">
                <div :class="this.examplePurpose == 'front' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'front' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课前</div>
              </div>
              <div @click="examplePurpose = 'middle'" class="flex align pointer">
                <div :class="this.examplePurpose == 'middle' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'middle' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课中</div>
              </div>
              <div @click="examplePurpose = 'back'" class="flex align pointer">
                <div :class="this.examplePurpose == 'back' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'back' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课后</div>
              </div>
            </div>
            <div v-show="!editableOrNot" class="examplePurpose-box flex spaceBetween">
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.examplePurpose == 'front' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'front' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课前</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.examplePurpose == 'middle' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'middle' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课中</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.examplePurpose == 'back' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.examplePurpose == 'back' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课后</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 习题用途部分结束 -->
      <!-- 习题题干部分开始 -->
      <div class="publicMarginTop">
        <div class="flex justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题题干:</div>
          </div>
          <div class="main-content-right">
            <my-editor ref="myEditor" :stem="stemTxt"></my-editor>
          </div>
        </div>
      </div>
      <!-- 习题题干部分结束 -->
      <!-- 单选题习题答案部分开始 -->
      <div v-if="this.selectType == 'single'" class="publicMarginTop">
        <div class="flex align justify">
          <div class="answer-box flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div class="main-content-right flex justify" style="flex-direction: column">
            <div class="option-box flex align" v-for="(item, index) in optionList" :key="index">
              <div v-show="!editableOrNot" style="cursor: not-allowed"
                :class="selectOptions == index ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
              <div class="option">{{ optionOrder[index] }}</div>
              <div class="inputBox">
                <textarea v-show="editableOrNot" rows="3" v-model="item.optionAnswer" class="publicInput" type="text"
                  placeholder="请输入选项" />
                <textarea v-show="!editableOrNot" rows="3" disabled v-model="item.optionAnswer" class="publicInput"
                  type="text" placeholder="请输入选项" />
              </div>
              <img v-show="editableOrNot" @click="btnDelete(index)" class="deleteBtn"
                src="../../assets/btnDelete.png" />
              <div v-show="editableOrNot" @click="selectOptions = index"
                :class="selectOptions == index ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 添加选项 -->
        <div class="flex spaceBetween">
          <div class="answer-box flex" style="visibility: hidden;">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div @click="addOption" class="addOption flex align pointer">
            <img src="../../assets/courseInformation/add.png" />
            <div class="addTxt">添加选项</div>
          </div>
        </div>
      </div>
      <!-- 单选题习题答案部分结束 -->
      <!-- 多选题习题答案部分开始 -->
      <div v-if="this.selectType == 'multi'" class="publicMarginTop">
        <div class="flex justify">
          <div class="flex" style="margin-top: 10px">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div class="main-content-right flex justify" style="flex-direction: column">
            <div class="flex align" style="margin-bottom: 10px" v-for="(item, index) in optionList" :key="index">
              <div v-show="editableOrNot" @click="multipleChoice(index)"
                :class="['uncheckedBox pointer', selectId.includes(index) ? 'checkedBox pointer' : 'uncheckedBox pointer']">
                <img src="../../assets/checkMark.png" />
              </div>
              <div v-show="!editableOrNot" style="cursor: not-allowed"
                :class="['uncheckedBox pointer', selectId.includes(index) ? 'checkedBox pointer' : 'uncheckedBox pointer']">
                <img src="../../assets/checkMark.png" />
              </div>
              <div class="option">{{ optionOrder[index] }}</div>
              <div class="inputBox">
                <textarea rows="3" v-model="item.optionAnswer" class="publicInput" type="text" placeholder="请输入选项" />
              </div>
              <img v-show="editableOrNot" @click="btnDelete(index)" class="deleteBtn"
                src="../../assets/btnDelete.png" />
            </div>
          </div>
        </div>
        <!-- 添加选项 -->
        <div class="flex spaceBetween">
          <div class="answer-box flex" style="visibility: hidden;">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div @click="addOption" class="addOption flex align pointer">
            <img src="../../assets/courseInformation/add.png" />
            <div class="addTxt">添加选项</div>
          </div>
        </div>
      </div>
      <!-- 多选题答案部分结束 -->
      <!-- 判断题习题答案部分开始 -->
      <div v-if="this.selectType == 'truefalse'" class="publicMarginTop">
        <div class="flex justify">
          <div class="flex" style="margin-top: 10px">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div class="main-content-right flex justify" style="flex-direction: column">
            <!-- 判断题A -->
            <div class="flex align" style="margin-bottom: 10px">
              <div v-show="editableOrNot" @click="selectOptions = 0"
                :class="selectOptions == 0 ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
              <div v-show="!editableOrNot" style="cursor: not-allowed"
                :class="selectOptions == 0 ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
              <div class="option">A</div>
              <div class="inputBox">
                <input class="publicInput1" disabled type="text" placeholder="正确" />
              </div>
            </div>
            <!-- 判断题B -->
            <div class="flex align" style="margin-bottom: 10px">
              <div v-show="editableOrNot" @click="selectOptions = 1"
                :class="selectOptions == 1 ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
              <div v-show="!editableOrNot" style="cursor: not-allowed"
                :class="selectOptions == 1 ? 'checkedBox pointer' : 'uncheckedBox pointer'">
                <img src="../../assets/checkMark.png" />
              </div>
              <div class="option">B</div>
              <div class="inputBox">
                <input class="publicInput1" disabled type="text" placeholder="错误" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 判断题答案部分结束 -->
      <!-- 填空题习题答案部分开始 -->
      <div v-if="this.selectType == 'blank'" class="publicMarginTop">
        <div class="flex justify">
          <div class="flex" style="margin-top: 10px">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div class="main-content-right flex justify" style="flex-direction: column">
            <div class="option-box flex align" v-for="(item, index) in optionList" :key="index">
              <div class="option blankOption">第{{ index + 1 }}空</div>
              <div class="inputBox">
                <textarea rows="3" v-show="editableOrNot" v-model="item.optionAnswer" class="publicInput" type="text"
                  placeholder="请输入答案" />
                <textarea rows="3" v-show="!editableOrNot" disabled v-model="item.optionAnswer" class="publicInput"
                  type="text" placeholder="请输入答案" />
              </div>
              <div class="blankOptionContent flex align">
                <input v-show="editableOrNot" @blur="blankBlur" class="linkageNameScore-text"
                  v-model="blankScoreList[index]" />
                <input v-show="!editableOrNot" disabled class="linkageNameScore-text" v-model="blankScoreList[index]" />
                <img v-show="editableOrNot" @click="btnDelete(index)" class="deleteBtn"
                  src="../../assets/btnDelete.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 添加选项 -->
        <div class="flex justify">
          <div class="flex" style="margin-top: 10px;visibility: hidden;">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">习题答案:</div>
          </div>
          <div class="main-content-right flex justify" style="flex-direction: column">
            <div class="option-box flex align">
              <div class="option blankOption" style="visibility: hidden;">第1空</div>
              <div @click="addOption" class="addOption flex align pointer">
                <img src="../../assets/courseInformation/add.png" />
                <div class="addTxt">添加选项</div>
              </div>
            </div>
          </div>
        </div>
        <div class="blankTips">如某一个空有多个正确答案请用“/”符号区分</div>
      </div>
      <!-- 填空题习题答案部分结束 -->
      <!-- 习题解析部分开始 -->
      <div class="publicMarginTop">
        <div class="flex justify">
          <div class="flex">
            <div class="requiredIcon1">*</div>
            <div class="informationTxt">习题解析:</div>
          </div>
          <div class="main-content-right">
            <my-editor ref="myEditor1" :stem="analysisTxt"></my-editor>
          </div>
        </div>
      </div>
      <!-- 习题解析部分结束 -->
      <!-- 按钮 -->
      <div v-show="editableOrNot" class="flex spaceBetween" style="width: 410px; margin-top: 100px">
        <div @click="btnUpload" class="pushButton pointer">上传</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-show="!editableOrNot" class="flex justify" style="width: 410px; margin-top: 100px">
        <div @click="btnCancel" class="pushButton pointer">返回</div>
      </div>
    </div>
  </div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import { Toast } from "vant";
import { toChinesNum } from "@/utils/util";
import { exerciseAddition, exerciseModification, resourceAssociationAdd, resourceAssociationDel } from "@/api";
import MyEditor from "@/components/MyEditor.vue";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      checked: [],
      selectClass: [], // 选择的课次列表
      showPopover: false,
      selectType: "single", // 当前选中的习题类型
      exampleageNameScore: 0, // 习题分值
      examplePurpose: "", // 当前选中的习题用途
      classList: [], // 所属课次
      selectOptions: -1, // 单选题正确答案
      multipleOptions: "", // 多选题答案
      classesList: [], // 所属课次列表
      optionsContent: "", // 所有选项的内容
      optionList: [
        {
          option: "A",
          optionAnswer: "",
        },
      ], // 选项列表
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      optionIdx: 0,
      selectId: [], // 已选列表
      stemTxt: "", // 题干内容
      analysisTxt: "", // 解析内容
      blankScoreList: [0], // 填空题分值列表
    };
  },
  components: {
    MyEditor,
  },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    this.classList = this.$store.state.classListRecord;
    console.log(this.$route.params.record);
    if (this.$route.params.record) {
      let xiu = this.$route.params.record;
      this.stemTxt = xiu.content; // 题干内容
      this.analysisTxt = xiu.comment; // 解析内容
      if (String(xiu.score).indexOf("分") !== -1) {
        this.exampleageNameScore = xiu.score.replace("分", ""); // 分值
      } else {
        this.exampleageNameScore = xiu.score; // 分值
      }
      // 所属课次
      if (xiu.lesson_items) {
        for (let i = 0; i < xiu.lesson_items.length; i++) {
          this.checked.push(xiu.lesson_items[i].name);
        }
      }
      this.optionList = [];
      // 习题选项
      for (let i = 0; i < xiu.options.length; i++) {
        let xiu1 = {
          option: this.optionOrder[i],
          optionAnswer: xiu.options[i],
        };
        this.optionList.push(xiu1);
      }
      // 习题答案
      this.selectOptions = xiu.answer[0];
      this.selectId = xiu.answer;
      // 习题用途
      if (xiu.usage == "课前") {
        this.examplePurpose = "front";
      } else if (xiu.usage == "课中") {
        this.examplePurpose = "middle";
      } else if (xiu.usage == "课后") {
        this.examplePurpose = "back";
      } else {
        this.examplePurpose = xiu.usage;
      }
      // 习题类型
      if (xiu.types == "单选题") {
        this.selectQuestionType(1);
      } else if (xiu.types == "多选题") {
        this.selectQuestionType(2);
      } else if (xiu.types == "判断题") {
        this.selectQuestionType(3);
      } else if (xiu.types == "简答题") {
        this.selectQuestionType(4);
      } else if (xiu.types == "填空题") {
        this.selectQuestionType(5);
        this.blankScoreList = xiu.scores;
      }
    }
    if (this.$route.params.whetherModified) {
      if (this.$route.params.whetherModified == "no") {
        this.editableOrNot = false;
      }
    }
  },
  methods: {
    blankBlur() {
      this.exampleageNameScore = 0;
      for (let i = 0; i < this.blankScoreList.length; i++) {
        this.exampleageNameScore += Number(this.blankScoreList[i]);
      }
    },
    // 更改习题所属课次
    changeCheckbox(classIdx, idx) {
      if (this.classesList.indexOf(idx) > -1) {
        this.classesList.splice(this.classesList.indexOf(idx), 1);
      } else {
        this.classesList.push(idx);
      }
      if (this.$route.params.record) {
        // console.log("当前选中的课次", classIdx);
        // console.log("课次数组", this.checked);
        // console.log("当前选中的课次下标", this.checked.indexOf(classIdx));
        if (this.checked.indexOf(classIdx) === -1) {
          // 删除习题课次关联
          let data = { resource_id: this.$route.params.record.id, lesson_item_id: idx, types: "examitem" };
          resourceAssociationDel(data).then((res) => { });
        } else {
          // 添加习题课次关联
          let data = { resource_id: this.$route.params.record.id, lesson_item_id: idx, lesson_id: this.$store.state.courseDetails.id, types: "examitem" };
          resourceAssociationAdd(data).then((res) => { });
        }
      }
    },
    // 选择的题目类型
    selectQuestionType(idx) {
      let { record } = this.$route.params;
      let xiu = { types: "", status: true };
      if (!record) xiu.status = false;
      // console.log(idx);
      if (idx == 1) {
        this.selectType = "single";
        if (xiu.types != "单选题" && xiu.status) return;
        this.selectOptions = -1;
        this.optionList = [
          {
            option: "A",
            optionAnswer: "",
          },
        ];
        // this.optionList[this.optionList.length - 1].optionAnswer = "";
      } else if (idx == 2) {
        this.selectType = "multi";
        if (xiu.types != "多选题" && xiu.status) return;
        this.selectOptions = 0;
        this.multipleOptions = "";
        this.optionList = [
          {
            option: "A",
            optionAnswer: "",
          },
        ];
        // this.optionList[this.optionList.length - 1].optionAnswer = "";
      } else if (idx == 3) {
        this.selectType = "truefalse";
        if (xiu.types != "判断题" && xiu.status) return;
        this.selectOptions = -1;
        this.optionList[this.optionList.length - 1].optionAnswer = "正确";
      } else if (idx == 4) {
        this.selectType = "answer";
        if (xiu.types != "简答题" && xiu.status) return;
        this.selectOptions = 0;
        this.optionList[this.optionList.length - 1].optionAnswer = "正确";
      } else if (idx == 5) {
        this.selectType = "blank";
        if (xiu.types != "填空题" && xiu.status) return;
        this.selectOptions = 0;
      }
    },
    setup(editor) {
      console.log(editor);
    },
    exampleageNameScoreInput() {
      let dom = document.getElementsByClassName("linkageNameScore-range")[0];
      let value = dom.value;
      if (value) this.exampleageNameScore = value;
    },
    // 多选题
    multipleChoice(idx) {
      if (!this.selectId.includes(idx)) {
        this.selectId.push(idx); // 判断已选列表中是否存在该id，不是则追加进去
      } else {
        let index = this.selectId.indexOf(idx); // 求出当前id的所在位置
        this.selectId.splice(index, 1); // 否则则删除
      }
    },
    // 上传按钮
    btnUpload() {
      console.log(this.checked);
      // console.log(this.$refs["myEditor"].getVal()); // 富文本
      // console.log(this.$refs["myEditor1"].getVal());
      // console.log(this.optionList[this.optionList.length - 1].optionAnswer);
      if (this.$store.state.courseDetails.id != "" && this.selectType != "" && this.$refs["myEditor"].getVal() && this.selectOptions != -1) {
        // 单项选择、多项选择选项内容
        for (let i = 0; i < this.optionList.length; i++) {
          if (this.optionList[i].optionAnswer != "") {
            this.optionsContent += this.optionList[i].optionAnswer + "|";
          }
        }
        // console.log(this.optionsContent);
        // 多项选择选项答案
        if (this.selectType == "multi") {
          for (let i = 0; i < this.selectId.length; i++) {
            this.multipleOptions += this.selectId[i] + ",";
          }
        }
        if (!this.$route.params.record) {
          let total1 = "";
          for (let i = 0; i < this.classesList.length; i++) {
            total1 += this.classesList[i] + ",";
          }
          let data = {
            lesson_id: this.$store.state.courseDetails.id,
            types: this.selectType,
            content: this.$refs["myEditor"].getVal().replace(/<[^>]+>/g, ""),
            options: this.optionsContent,
            score: this.exampleageNameScore,
            lesson_item_ids: total1,
            usage: this.examplePurpose,
            answer: this.selectType == "multi" ? this.multipleOptions : this.selectOptions,
            comment: this.$refs["myEditor1"].getVal().replace(/<[^>]+>/g, ""),
          };
          // 填空题
          if (this.selectType == "blank") {
            data.scores = this.blankScoreList.map((item) => item).join(",");
          }
          // 习题添加
          exerciseAddition(data).then((res) => {
            if (res.data.code == 0) {
              if (this.$route.params.comeFrom == "addTopic") {
                // console.log(res.data.datas.score + "分");
                res.data.datas.score = res.data.datas.score + "分";
                this.$router.push({
                  name: "addTestPaper",
                  params: { topicData: res.data.datas, method: "handMovement", record: this.$route.params.examId },
                });
              } else if (this.$route.params.comeFrom == "testPaperComposition") {
                // console.log(res.data.datas.score + "分");
                res.data.datas.score = res.data.datas.score + "分";
                this.$router.push({
                  name: "manualTestComposition",
                  params: { topicData: res.data.datas, method: "handMovement", record: this.$route.params.examId },
                });
              } else if (this.$route.params.comeFrom == "automaticTestComposition") {
                this.$router.push({
                  name: "automaticTestComposition",
                  params: { topicData: res.data.datas, method: "handMovement" },
                });
              } else if (this.$route.params.comeFrom == "prepareLessons") {
                this.$router.push({
                  name: "courseTeaching",
                  params: {},
                });
              } else {
                Toast("上传成功！");
                this.$router.push("/resourceManagement");
              }
            }
          });
        } else {
          let data = {
            score: this.exampleageNameScore,
            usage: this.examplePurpose,
            content: this.$refs["myEditor"].getVal().replace(/<[^>]+>/g, ""),
            options: this.optionsContent,
            answer: this.selectType == "multi" ? this.multipleOptions : this.selectOptions,
            types: this.selectType,
            comment: this.$refs["myEditor1"].getVal().replace(/<[^>]+>/g, ""),
            level: "",
            id: this.$route.params.record.id,
          };
          // 填空题
          if (this.selectType == "blank") {
            data.scores = "";
            for (let i = 0; i < this.blankScoreList.length; i++) {
              data.scores += this.blankScoreList[i] + ",";
            }
          }
          // 习题修改
          exerciseModification(data).then((res) => {
            if (res.data.code == 0) {
              // this.$router.push("/resourceManagement");
              this.$router.go(-1);
              // window.history.go(-1);
              if (this.$route.params.examId) this.cookie.set("ExamId", this.$route.params.examId);
              Toast("修改成功！");
            }
          });
        }
      } else {
        for (let i = 0; i < this.optionList.length; i++) {
          if (this.examplePurpose == "") {
            Toast("请选择习题用途！");
          } else if (!this.$refs["myEditor"].getVal()) {
            Toast("请输入习题题干!");
          } else if (this.optionList[this.optionList.length - 1].optionAnswer == "") {
            Toast("请输入选项！");
          } else if (this.selectOptions == -1 && this.selectType != "answer") {
            Toast("请选择正确答案！");
          }
        }
      }
    },
    // 取消按钮
    btnCancel() {
      // this.$router.push("/resourceManagement");
      this.$router.go(-1);
      // window.history.go(-1);
      if (this.$route.params.examId) this.cookie.set("ExamId", this.$route.params.examId);
    },
    // 添加选项
    addOption() {
      if (this.optionList[this.optionList.length - 1].optionAnswer == "" && this.selectType != "blank") {
        Toast("请输入选项！");
      } else if (this.optionList[this.optionList.length - 1].optionAnswer == "" && this.selectType == "blank") {
        Toast("请输入答案或答案分值！");
      } else {
        if (this.selectType == "blank") {
          this.blankScoreList.push(0);
        }
        this.optionIdx++;
        if (this.optionIdx < this.optionOrder.length) {
          let xiu = {
            option: this.optionOrder[this.optionIdx],
            optionAnswer: "",
          };
          this.optionList.push(xiu);
        }
      }
    },
    btnDelete(idx) {
      if (idx == 0) {
        Toast("最后一个选项不能删除！");
      } else {
        this.optionList.splice(idx, 1);
        if (this.selectType == "blank") {
          this.blankScoreList.splice(idx, 1);
          this.exampleageNameScore = 0;
          for (let i = 0; i < this.blankScoreList.length; i++) {
            this.exampleageNameScore += Number(this.blankScoreList[i]);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.blankOptionContent {
  position: absolute;
  right: -88px;
}

.blankOption {
  width: 100px;
}

.deleteBtn {
  position: absolute;
  width: 20px;
  height: 20px;
  right: -30px;
}

.pointer {
  cursor: pointer;
}



.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow: scroll;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.requiredIcon1 {
  opacity: 0;
}

.informationTxt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

.selectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superSelectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  opacity: 0.5;
  cursor: not-allowed;
}

.unSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superUnSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: not-allowed;
}

.main-content-right {
  position: relative;
  width: 940px;
  margin-left: 35px;
}

/* 公共输入框样式 */
.publicInput-box {
  width: 940px;
  height: auto;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  width: 820px;
  height: auto;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
  resize: vertical;
  padding: 5px 10px;
  box-sizing: border-box;
}

.publicInput1 {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 659px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

/* 资源分值滑块 */
.linkageNameScore-range {
  display: flex;
  align-items: center;
}

input[type="range"] {
  appearance: none;
  width: 368px;
  border-radius: 10px;
  /*这个属性设置使填充进度条时的图形为圆角*/
}

/* 自定义进度条 */
input[type="range"]::-webkit-slider-runnable-track {
  width: 368px;
  height: 6px;
  background: #dddddd;
  border-radius: 3px;
  cursor: pointer;
}

/* 自定义滑块 */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  /*清除系统默认样式*/
  width: 20px;
  height: 20px;
  background: #349afe;
  border-radius: 50%;
  margin-top: -7px;
  /* 使滑块超出轨道部分的偏移量相等 */
  cursor: e-resize;
}

.linkageNameScore-text {
  margin-left: 24px;
  width: 64px;
  height: 35px;
  border: 1px solid #757575;
  border-radius: 10px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  background-color: transparent;
  outline: none;
  text-align: center;
}

.selectLinkCircle {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectLinkCircle {
  width: 8px;
  height: 8px;
  border: 2px solid #b8b8b8;
  border-radius: 50%;
}

.selectLinkTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.unSelectLinkTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
}

.selectClass-box {
  width: 761px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: auto;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.checkedBox {
  position: absolute;
  right: -60px;
  // margin-left: 10px;
  width: 20px;
  height: 20px;
  border: 1px solid #757575;
  border-radius: 5px;
  background: #349afe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uncheckedBox {
  position: absolute;
  right: -60px;
  width: 20px;
  height: 20px;
  border: 1px solid #757575;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.option {
  margin-left: 19px;
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.inputBox {
  margin-left: 16px;
  width: calc(946px - 6px);
  height: auto;
  border: 1px solid #757575;
  border-radius: 10px;
}

.addOption {
  width: 890px;
  height: 50px;
  border: 1px dashed #757575;
  border-radius: 10px;
  padding: 16px 19px;
  box-sizing: border-box;
}

.addTxt {
  margin-left: 8px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.questionType-box {
  width: 759px;
}

.publicMarginTop {
  margin-top: 30px;
}

.examplePurpose-box {
  width: 262px;
}

.option-box {
  margin-bottom: 10px;
}

.answer-box {
  margin-top: -10px;
}

.blankTips {
  margin-top: 9px;
  margin-left: 590px;

  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #349afe;
}
</style>
